import { useCallback, useEffect, useRef } from "react";
import { httpUser } from "../config/BaseUrl";
import { isTwoWaySmsEnabled } from "../pages/SmsBilling/smsAccess";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("users"));
  } catch (error) {
    return null;
  }
};

const useRefreshStoredUser = () => {
  const refreshingRef = useRef(false);

  const refreshStoredUser = useCallback(async () => {
    const storedUser = getStoredUser();

    if (!storedUser || refreshingRef.current) {
      return;
    }

    refreshingRef.current = true;

    try {
      const accessToken = localStorage.getItem("token_verify");
      const response = await httpUser.get("/user", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const freshUser = response?.data?.user || response?.data;

      if (!freshUser || typeof freshUser !== "object") {
        return;
      }

      const updatedUser = { ...storedUser, ...freshUser };
      const smsAccessChanged =
        isTwoWaySmsEnabled(storedUser) !== isTwoWaySmsEnabled(updatedUser);

      localStorage.setItem("users", JSON.stringify(updatedUser));

      if (smsAccessChanged) {
        window.location.reload();
      }
    } catch (error) {
      // Keep the existing session data when the profile request is unavailable.
    } finally {
      refreshingRef.current = false;
    }
  }, []);

  useEffect(() => {
    refreshStoredUser();

    const handleFocus = () => refreshStoredUser();
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshStoredUser();
      }
    };

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [refreshStoredUser]);
};

export default useRefreshStoredUser;
